import React, { Component, Fragment } from 'react';

import { ModalWithoutPortal } from 'components/modal/ModalWithoutPortal';
import { I18n } from 'components/translate';
import { modalTypes } from 'modules/classManager/constants';
import PropTypes from 'prop-types';

export default class ModalClass extends Component {
  static propTypes = {
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    type: PropTypes.string.isRequired
  };

  onConfirm = () => {
    const { onConfirm, type } = this.props;

    onConfirm && onConfirm(type);
  };

  onCancel = () => {
    const { onCancel, type } = this.props;

    onCancel && onCancel(type);
  };

  render() {
    const modalType = modalTypes[this.props.type];

    return (
      <ModalWithoutPortal title={modalType.title} onClose={this.onCancel}>
        <ModalWithoutPortal.Body>
          <p>
            <I18n label={modalType.body} />
          </p>
        </ModalWithoutPortal.Body>
        <ModalWithoutPortal.Footer>
          <Fragment>
            <button
              className="hot-button hot-button--primary hot-button--lg"
              onClick={this.onConfirm}
            >
              <I18n label="general.ok" />
            </button>
            <button
              className="hot-button hot-button--secondary hot-button--lg"
              onClick={this.onCancel}
            >
              <I18n label="general.cancel" />
            </button>
          </Fragment>
        </ModalWithoutPortal.Footer>
      </ModalWithoutPortal>
    );
  }
}
